import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getProgress } from '../services/api';
import BrandLogo from '../components/wizard/BrandLogo';

/**
 * Shown after the client submits the completed Annual Check-In.
 */
export default function CompletePage() {
  const { client, logout } = useAuth();
  const [clientType, setClientType] = useState('hff');

  useEffect(() => {
    getProgress()
      .then((data) => {
        setClientType(data.client_type || 'hff');
      })
      .catch(() => { /* non-fatal */ });
  }, []);

  const themeClass = clientType === 'rebellionaire' ? 'theme-rebellionaire' : '';

  return (
    <div className={`cashflow-login-bg d-flex justify-content-center align-items-center min-vh-100 py-4 ${themeClass}`}>
      <div className="card shadow-sm p-4" style={{ maxWidth: 640, width: '100%' }}>
        <div className="text-center">
          <BrandLogo size={64} className="mb-3" />
          <h2 className="h4 fw-bold cashflow-brand-text mb-2">
            Thank You{client?.name ? `, ${client.name.split(' ')[0]}` : ''}!
          </h2>
          <p className="text-muted mb-4">
            Your Annual Check-In has been submitted. Your advisor will
            review your responses ahead of your next conversation.
          </p>
        </div>

        <div className="d-flex gap-2 justify-content-center flex-wrap mt-3">
          <Link to="/wizard" className="btn btn-outline-secondary">
            <i className="bi bi-pencil me-1" />
            Review My Answers
          </Link>
          <button className="btn btn-outline-danger" onClick={logout}>
            <i className="bi bi-box-arrow-right me-1" />
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}
